var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-detail container page-content" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-5 product-detail__carousel" },
        [
          _c("item-image-carousel", {
            attrs: {
              "plugin-path": _vm.pluginPath,
              "image-url-accessor": "url",
              "preview-variation-image": _vm.previewVariationImage,
            },
          }),
          _vm._v(" "),
          _vm.currentVariation.item.free1 || _vm.ytVideos.length > 0
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "headline__24 product-detail__yt-title" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.productVideos")
                        ) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "product-detail__yt-row" },
                  [
                    _vm.currentVariation.item.free1
                      ? _c("youtube-modal", {
                          attrs: {
                            "video-id": _vm.currentVariation.item.free1,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.ytVideos, function (group) {
                      return [
                        _vm._l(group.properties, function (property) {
                          return property.values && property.values.value
                            ? [
                                _c("youtube-modal", {
                                  attrs: {
                                    "video-id": property.values.value.replace(
                                      /<[^>]*>?/gm,
                                      ""
                                    ),
                                  },
                                }),
                              ]
                            : _vm._e()
                        }),
                      ]
                    }),
                  ],
                  2
                ),
              ])
            : _c("div", { staticClass: "product-detail__yt-spacer" }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-12 col-md-7 offset-xl-1 col-xl-6 product-detail__details",
        },
        [
          _c("div", { staticClass: "product-detail__intro" }, [
            _c("div", { staticClass: "product-detail__producer" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.currentVariation.filter.hasManufacturer
                      ? _vm.currentVariation.item.manufacturer.externalName
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "product-detail__ratings",
                on: { click: _vm.scrollToReviews },
              },
              [
                _c("od-feedback-average", {
                  attrs: {
                    "show-empty-ratings": true,
                    "size-of-stars": "small",
                    "show-ratings-amount": true,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "h1",
            {
              staticClass: "product-detail__title",
              attrs: { "data-testing": "item-name" },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("itemName")(_vm.currentVariation)) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "list-group product-detail__attr-info-list" },
            [
              _c(
                "li",
                {
                  staticClass:
                    "list-group-item product-detail__attr-info-list-item",
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$translate("OD3dprimaV2::Template.ItemNo")) +
                      "\n                    "
                  ),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.itemId) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass:
                    "list-group-item product-detail__attr-info-list-item",
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$translate("OD3dprimaV2::Template.variationId")
                      ) +
                      "\n                    "
                  ),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.currentVariation.variation.id) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.ean
                ? _c(
                    "li",
                    {
                      staticClass:
                        "list-group-item product-detail__attr-info-list-item",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("OD3dprimaV2::Template.variationEAN")
                          ) +
                          "\n                    "
                      ),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.ean.code) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentVariation.variation.model
                ? _c(
                    "li",
                    {
                      staticClass:
                        "list-group-item product-detail__attr-info-list-item",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.variationPartNo"
                            )
                          ) +
                          "\n                    "
                      ),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.currentVariation.variation.model) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.currentVariation.bundleComponents
            ? _c("div", [
                _c("div", { staticClass: "bundle__title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$translate("OD3dprimaV2::Template.bundleTitle")
                      ) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "bundle__list" },
                  _vm._l(
                    _vm.currentVariation.bundleComponents,
                    function (bundleList) {
                      return _c("li", { staticClass: "bundle__item" }, [
                        _c("span", { staticClass: "bundle__item-qty-value" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(bundleList.quantity) +
                              "x\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "bundle__item-link",
                            attrs: {
                              href: _vm._f("itemURL")(bundleList.data, true),
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(bundleList.data.texts.name1) +
                                "\n                            "
                            ),
                            bundleList.data.variation &&
                            bundleList.data.variation.name
                              ? [
                                  _vm._v(
                                    "\n                                - " +
                                      _vm._s(bundleList.data.variation.name) +
                                      "\n                            "
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    }
                  ),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "product-detail__short-wrapper" }, [
            _vm.currentVariation.texts.shortDescription !== ""
              ? _c(
                  "div",
                  {
                    staticClass: "product-detail__short-description",
                    class: _vm.showMore
                      ? "product-detail__short-description--show"
                      : "",
                  },
                  [
                    _c("client-only", [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.currentVariation.texts.shortDescription
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center product-detail__show-more d-md-none",
                        on: {
                          click: function ($event) {
                            _vm.showMore = !_vm.showMore
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.showMore
                                  ? _vm.$translate(
                                      "OD3dprimaV2::Template.readLess"
                                    )
                                  : _vm.$translate(
                                      "OD3dprimaV2::Template.readMore"
                                    )
                              ) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.attributes.length || Object.keys(_vm.units).length
            ? _c(
                "div",
                { staticClass: "product-detail__variation" },
                [
                  _c("variation-select", {
                    on: {
                      showPreviewImage: function ($event) {
                        _vm.previewVariationImage = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("tag-list"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-xl-6" },
              [
                _vm._t("before-price"),
                _vm._v(" "),
                _vm.currentVariation.prices.default.unitPrice.value > 0
                  ? _c("item-price", {
                      attrs: {
                        "show-cross-price": _vm.isRecommendedPriceActive,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("graduated-prices"),
                _vm._v(" "),
                _vm.activeCategoryDiscount && _vm.showCategoryDiscountTable
                  ? _c("div", { staticClass: "category-discount" }, [
                      _c("b", { staticClass: "category-discount__title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.categoryDiscountTitle"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "table",
                        { staticClass: "category-discount__table text-muted" },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.categoryDiscountColQty"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.categoryDiscountColPercent"
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.activeCategoryDiscount.tiers,
                              function (tier, index) {
                                return _c("tr", { key: index }, [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "OD3dprimaV2::Template.categoryDiscountQty",
                                          { qty: tier.minQty }
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(tier.percent) + " %"),
                                  ]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("small", { staticClass: "category-discount__hint" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.categoryDiscountHint"
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("after-price"),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-xl-6" },
              [
                _vm._t("additional-content-after-vat"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "product-detail__shipping-info" },
                  [
                    _c("div", { staticClass: "product-detail-stock" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "product-detail-stock__svg",
                          class: {
                            "product-detail-stock__svg--no-stock":
                              _vm.currentVariation.stock.net < 1,
                          },
                          attrs: { xmlns: "http://www.w3.org/2000/svg" },
                        },
                        [
                          _c("use", {
                            attrs: {
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              "xlink:href": "#svg-shipping",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$translate("OD3dprimaV2::Template.itemStock")
                          ) +
                          ": \n                            "
                      ),
                      _c("strong", [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.stock) +
                            "\n                            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("item-availability", {
                      staticClass: "product-detail__availability",
                      attrs: { "item-id": _vm.itemId },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm._t("before-add-to-basket"),
          _vm._v(" "),
          _vm.currentVariation.item.itemType === "set"
            ? _c("div", { staticClass: "alert alert-info w-100" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$translate("Ceres::Template.singleItemSetInfo")
                    ) +
                    "\n            "
                ),
              ])
            : _c(
                "div",
                { staticClass: "product-detail__add-to-basket row" },
                [
                  _vm.activeCategoryDiscount && _vm.showCategoryDiscountProgress
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("category-discount-progress", {
                            attrs: {
                              rules: _vm.categoryDiscountRules,
                              "category-ids": _vm.categoryDiscountCategoryIds,
                              adding: _vm.categoryDiscountOrderQuantity,
                              "variation-id": _vm.currentVariation.variation.id,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.prices.default.unitPrice.value > 0
                    ? _c("add-to-basket", {
                        staticClass: "col-12",
                        attrs: {
                          "variation-id": _vm.currentVariation.variation.id,
                          "is-salable":
                            !!_vm.currentVariation.filter &&
                            _vm.currentVariation.filter.isSalable,
                          "has-children":
                            !!_vm.currentVariation.filter &&
                            _vm.currentVariation.filter.hasActiveChildren,
                          "interval-quantity":
                            _vm.currentVariation.variation
                              .intervalOrderQuantity || 1,
                          "minimum-quantity":
                            _vm.currentVariation.variation.minimumOrderQuantity,
                          "maximum-quantity":
                            !!_vm.currentVariation.variation
                              .maximumOrderQuantity &&
                            _vm.currentVariation.variation
                              .maximumOrderQuantity > 0
                              ? _vm.currentVariation.variation
                                  .maximumOrderQuantity
                              : null,
                          "order-properties":
                            _vm.currentVariation.properties.filter(function (
                              prop
                            ) {
                              return prop.property.isOderProperty
                            }),
                          "has-order-properties":
                            _vm.currentVariation.hasOrderProperties,
                          "has-required-order-property":
                            _vm.currentVariation.hasRequiredOrderProperty,
                          "use-large-scale": false,
                          "show-quantity": true,
                          "item-url": _vm._f("itemURL")(_vm.currentVariation),
                          "is-variation-selected":
                            _vm.isVariationSelected &&
                            _vm.currentVariation.filter.isSalable,
                          "has-price": _vm._f("hasItemDefaultPrice")(
                            _vm.currentVariation
                          ),
                          "item-free-four": String(
                            _vm.currentVariation.item.free4
                          ),
                        },
                      })
                    : _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-block btn-primary btn-appearance add-to-basket__btn",
                          on: {
                            click: function ($event) {
                              return _vm.scrollToContact()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$translate(
                                  "OD3dprimaV2::Template.contactForAQuote"
                                )
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                ],
                1
              ),
          _vm._v(" "),
          _c("div", { staticClass: "product-detail__info-wrapper" }, [
            _c(
              "div",
              { staticClass: "product-detail__wishlist-wrapper" },
              [
                _vm.currentVariation.prices.default.unitPrice.value > 0
                  ? _c("add-to-wish-list", {
                      attrs: {
                        "variation-id": _vm.currentVariation.variation.id,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.currentVariation.prices.default.unitPrice.value > 0
              ? _c("div", { staticClass: "product-detail-question" }, [
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.scrollToContact()
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "product-detail-question__svg",
                          attrs: { xmlns: "http://www.w3.org/2000/svg" },
                        },
                        [
                          _c("use", {
                            attrs: {
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              "xlink:href": "#svg-question",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.productQuestion"
                            )
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "product-detail-question" }, [
              _vm.hasManufacturerDataPart2 || _vm.hasManufacturerDataPart1
                ? _c(
                    "a",
                    {
                      staticClass: "d-block",
                      attrs: {
                        "data-target": "#eusafety",
                        "data-toggle": "modal",
                        href: "#",
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "product-detail-question__svg",
                          attrs: { xmlns: "http://www.w3.org/2000/svg" },
                        },
                        [
                          _c("use", {
                            attrs: {
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              "xlink:href": "#svg-info",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.manufacturerInfo"
                            )
                          ) +
                          "\n\n                    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm._t("after-add-to-basket"),
          _vm._v(" "),
          _vm._t("additional-content-after-add-to-basket"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "single-crossselling__wrapper" },
            [_vm._t("crosssellingbasket")],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-xl-8 order-xl-2" }, [
        _c(
          "div",
          { attrs: { id: "id--accordion" } },
          [
            _c(
              "div",
              {
                staticClass: "accordion__header",
                attrs: { id: "id--accordion__header-1" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "headline__24",
                    attrs: {
                      "data-toggle": "collapse",
                      "data-target": "#id--accordion__collapse-1",
                      "aria-controls": "id--accordion__collapse-1",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$translate(
                            "OD3dprimaV2::Template.singleDescription"
                          )
                        ) +
                        "\n                        "
                    ),
                    _c(
                      "svg",
                      { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                      [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#svg-caret",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.isMounted
              ? _c(
                  "portal",
                  {
                    attrs: {
                      to: "desktop-accordion-1",
                      disabled: _vm.isMobile,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "articleDescription",
                        staticClass: "collapse show",
                        attrs: {
                          id: "id--accordion__collapse-1",
                          "aria-labelledby": "id--accordion__header-1",
                          "data-parent": "#id--accordion",
                        },
                      },
                      [
                        _c("client-only", [
                          _c("div", {
                            staticClass: "accordion__body",
                            domProps: { innerHTML: _vm._s(_vm._lazyContent) },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.currentUrl !== _vm.canonicalUrl
                          ? _c("a", { attrs: { href: _vm.canonicalUrl } }, [
                              _vm._v(
                                _vm._s(_vm._f("itemName")(_vm.currentVariation))
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              : [
                  _c(
                    "div",
                    {
                      ref: "articleDescription",
                      staticClass: "collapse show",
                      attrs: {
                        id: "id--accordion__collapse-1",
                        "aria-labelledby": "id--accordion__header-1",
                        "data-parent": "#id--accordion",
                      },
                    },
                    [
                      _c("client-only", [
                        _c("div", {
                          staticClass: "accordion__body",
                          domProps: { innerHTML: _vm._s(_vm._lazyContent) },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.currentUrl !== _vm.canonicalUrl
                        ? _c("a", { attrs: { href: _vm.canonicalUrl } }, [
                            _vm._v(
                              _vm._s(_vm._f("itemName")(_vm.currentVariation))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
            _vm._v(" "),
            _vm.currentVariation.texts.technicalData
              ? _c(
                  "div",
                  {
                    staticClass: "accordion__header",
                    attrs: { id: "id--accordion__header-2" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "collapsed headline__24",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": "#id--accordion__collapse-2",
                          "aria-controls": "id--accordion__collapse-2",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate(
                                "OD3dprimaV2::Template.singleTechnicalData"
                              )
                            ) +
                            "\n                        "
                        ),
                        _c(
                          "svg",
                          { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                          [
                            _c("use", {
                              attrs: {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": "#svg-caret",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isMounted
              ? _c(
                  "portal",
                  {
                    attrs: {
                      to: "desktop-accordion-2",
                      disabled: _vm.isMobile,
                    },
                  },
                  [
                    _vm.currentVariation.texts.technicalData !== ""
                      ? _c(
                          "div",
                          {
                            staticClass: "collapse",
                            attrs: {
                              id: "id--accordion__collapse-2",
                              "aria-labelledby": "id--accordion__header-2",
                              "data-parent": "#id--accordion",
                            },
                          },
                          [
                            _c("div", {
                              staticClass: "accordion__body",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.currentVariation.texts.technicalData
                                ),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : [
                  _vm.currentVariation.texts.technicalData !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "collapse",
                          attrs: {
                            id: "id--accordion__collapse-2",
                            "aria-labelledby": "id--accordion__header-2",
                            "data-parent": "#id--accordion",
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "accordion__body",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.technicalData
                              ),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
            _vm._v(" "),
            _vm.whatsIncluded
              ? _c(
                  "div",
                  {
                    staticClass: "accordion__header",
                    attrs: { id: "id--accordion__header-3" },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "reviewsHeader",
                        staticClass: "collapsed headline__24",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": "#id--accordion__collapse-3",
                          "aria-expanded": "false",
                          "aria-controls": "id--accordion__collapse-3",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate(
                                "OD3dprimaV2::Template.singleIncluded"
                              )
                            ) +
                            "\n                        "
                        ),
                        _c(
                          "svg",
                          { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                          [
                            _c("use", {
                              attrs: {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": "#svg-caret",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isMounted
              ? _c(
                  "portal",
                  {
                    attrs: {
                      to: "desktop-accordion-3",
                      disabled: _vm.isMobile,
                    },
                  },
                  [
                    _vm.whatsIncluded
                      ? _c(
                          "div",
                          {
                            staticClass: "collapse",
                            attrs: {
                              id: "id--accordion__collapse-3",
                              "aria-labelledby": "id--accordion__header-3",
                              "data-parent": "#id--accordion",
                            },
                          },
                          [
                            _c("div", {
                              staticClass: "accordion__body",
                              domProps: {
                                innerHTML: _vm._s(_vm.whatsIncluded),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : [
                  _vm.whatsIncluded
                    ? _c(
                        "div",
                        {
                          staticClass: "collapse",
                          attrs: {
                            id: "id--accordion__collapse-3",
                            "aria-labelledby": "id--accordion__header-3",
                            "data-parent": "#id--accordion",
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "accordion__body",
                            domProps: { innerHTML: _vm._s(_vm.whatsIncluded) },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion__header",
                attrs: { id: "id--accordion__header-4" },
              },
              [
                _c(
                  "div",
                  {
                    ref: "reviewsHeader",
                    staticClass: "collapsed headline__24",
                    attrs: {
                      "data-toggle": "collapse",
                      "data-target": "#id--accordion__collapse-4",
                      "aria-controls": "id--accordion__collapse-4",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.singleRatings")
                        ) +
                        "\n                        "
                    ),
                    _c(
                      "svg",
                      { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                      [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#svg-caret",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.isMounted
              ? _c(
                  "portal",
                  {
                    attrs: {
                      to: "desktop-accordion-4",
                      disabled: _vm.isMobile,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "reviewsTab",
                        staticClass: "collapse",
                        attrs: {
                          id: "id--accordion__collapse-4",
                          "aria-labelledby": "id--accordion__header-4",
                          "data-parent": "#id--accordion",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "accordion__body" },
                          [
                            _c(
                              "client-only",
                              [
                                _c("feedback-container", {
                                  attrs: { options: _vm.feedbackOptions },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              : [
                  _c(
                    "div",
                    {
                      ref: "reviewsTab",
                      staticClass: "collapse",
                      attrs: {
                        id: "id--accordion__collapse-4",
                        "aria-labelledby": "id--accordion__header-4",
                        "data-parent": "#id--accordion",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "accordion__body" },
                        [
                          _c(
                            "client-only",
                            [
                              _c("feedback-container", {
                                attrs: { options: _vm.feedbackOptions },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
            _vm._v(" "),
            _vm.dataSheets.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "accordion__header",
                    attrs: { id: "id--accordion__header-5" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "collapsed headline__24",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": "#id--accordion__collapse-5",
                          "aria-expanded": "false",
                          "aria-controls": "id--accordion__collapse-5",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate(
                                "OD3dprimaV2::Template.singleDataSheets"
                              )
                            ) +
                            "\n                        "
                        ),
                        _c(
                          "svg",
                          { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                          [
                            _c("use", {
                              attrs: {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": "#svg-caret",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion__header accordion__header--faq ",
                attrs: { id: "id--accordion__header-6" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "collapsed headline__24",
                    attrs: {
                      "data-toggle": "collapse",
                      "data-target": "#id--accordion__collapse-6",
                      "aria-expanded": "false",
                      "aria-controls": "id--accordion__collapse-6",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        FAQ\n                        "
                    ),
                    _c(
                      "svg",
                      { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                      [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#svg-caret",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "client-only",
              [
                _c("od-portal-target", {
                  attrs: { name: "desktop-accordion-1" },
                }),
                _vm._v(" "),
                _c("od-portal-target", {
                  attrs: { name: "desktop-accordion-2" },
                }),
                _vm._v(" "),
                _c("od-portal-target", {
                  attrs: { name: "desktop-accordion-3" },
                }),
                _vm._v(" "),
                _c("od-portal-target", {
                  attrs: { name: "desktop-accordion-4" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.dataSheets.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "collapse",
                    attrs: {
                      id: "id--accordion__collapse-5",
                      "aria-labelledby": "id--accordion__header-5",
                      "data-parent": "#id--accordion",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "accordion__body" },
                      [
                        _vm._l(_vm.dataSheets, function (group) {
                          return _vm._l(group.properties, function (property) {
                            return _c("div", { staticClass: "mt-2" }, [
                              property.cast === "file"
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        attrs: {
                                          href: _vm._f("propertyFileUrl")(
                                            property.values.value
                                          ),
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "18",
                                              height: "14",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              attrs: {
                                                "xmlns:xlink":
                                                  "http://www.w3.org/1999/xlink",
                                                "xlink:href": "#svg-download",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "pl-2" }, [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm._f("propertyName")(
                                                  property.names
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(property.values.value),
                                    },
                                  }),
                            ])
                          })
                        }),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse accordion__body--faq",
                attrs: {
                  id: "id--accordion__collapse-6",
                  "aria-labelledby": "id--accordion__header-6",
                  "data-parent": "#id--accordion",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "accordion__body" },
                  [
                    _vm._l(30, function (i) {
                      return _vm.$translate(
                        "OD3dprimaV2::Template.faq" + i + "Title"
                      ) &&
                        _vm.$translate(
                          "OD3dprimaV2::Template.faq" + i + "Content"
                        ) &&
                        _vm.$translate(
                          "OD3dprimaV2::Template.faq" + i + "Title"
                        ) !== "" &&
                        _vm.$translate(
                          "OD3dprimaV2::Template.faq" + i + "Content"
                        ) !== "" &&
                        _vm.isCurrentCategory(
                          _vm.$translate(
                            "OD3dprimaV2::Template.faq" + i + "CategoryId"
                          )
                        )
                        ? _c("div", { key: i }, [
                            _c(
                              "div",
                              {
                                staticClass: "faq__header",
                                attrs: { id: "id--faq-accordion__header-" + i },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapsed",
                                    attrs: {
                                      "data-toggle": "collapse",
                                      "data-target":
                                        "#id--faq-accordion__collapse-" + i,
                                      "aria-expanded": "false",
                                      "aria-controls":
                                        "id--faq-accordion__collapse-" + i,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$translate(
                                            "OD3dprimaV2::Template.faq" +
                                              i +
                                              "Title"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xmlns:xlink":
                                              "http://www.w3.org/1999/xlink",
                                            "xlink:href": "#svg-caret",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "collapse",
                                attrs: {
                                  id: "id--faq-accordion__collapse-" + i,
                                  "aria-labelledby":
                                    "id--faq-accordion__header-" + i,
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "faq__body",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$translate(
                                        "OD3dprimaV2::Template.faq" +
                                          i +
                                          "Content"
                                      )
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(5, function (i) {
                      return _vm.$translate(
                        "OD3dprimaV2::Template.faqGlobal" + i + "Title"
                      ) &&
                        _vm.$translate(
                          "OD3dprimaV2::Template.faqGlobal" + i + "Content"
                        ) &&
                        _vm.$translate(
                          "OD3dprimaV2::Template.faqGlobal" + i + "Title"
                        ) !== "" &&
                        _vm.$translate(
                          "OD3dprimaV2::Template.faqGlobal" + i + "Content"
                        ) !== ""
                        ? _c("div", { key: i }, [
                            _c(
                              "div",
                              {
                                staticClass: "faq__header",
                                attrs: {
                                  id:
                                    "id--faq-accordion__header-" +
                                    i +
                                    "-global",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapsed",
                                    attrs: {
                                      "data-toggle": "collapse",
                                      "data-target":
                                        "#id--faq-accordion__collapse-" +
                                        i +
                                        "-global",
                                      "aria-expanded": "false",
                                      "aria-controls":
                                        "id--faq-accordion__collapse-" +
                                        i +
                                        "-global",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$translate(
                                            "OD3dprimaV2::Template.faqGlobal" +
                                              i +
                                              "Title"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xmlns:xlink":
                                              "http://www.w3.org/1999/xlink",
                                            "xlink:href": "#svg-caret",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "collapse",
                                attrs: {
                                  id:
                                    "id--faq-accordion__collapse-" +
                                    i +
                                    "-global",
                                  "aria-labelledby":
                                    "id--faq-accordion__header-" +
                                    i +
                                    "-global",
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "faq__body",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$translate(
                                        "OD3dprimaV2::Template.faqGlobal" +
                                          i +
                                          "Content"
                                      )
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ]
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-xl-4 order-xl-1" }, [
        _c(
          "div",
          { staticClass: "product-detail__cross-selling" },
          [_vm._t("item-list-container")],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 offset-xl-3 col-xl-8 order-xl-3" }, [
        _c("div", { staticClass: "product-detail__form" }, [
          _c(
            "h3",
            {
              ref: "contactFormTitle",
              staticClass: "headline__40 headline__border-bottom",
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$translate("OD3dprimaV2::Template.productQuestion")
                  ) +
                  "?\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              ref: "contactForm",
              attrs: { name: "contact", id: "contact-form" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "input-unit input-unit--floating input-name-field",
                },
                [
                  _c("input", {
                    staticClass: "input-product-name",
                    attrs: {
                      disabled: "",
                      type: "text",
                      name: "item",
                      id: "form_item",
                      required: "",
                    },
                    domProps: {
                      value:
                        _vm.currentVariation.texts.name1 +
                        ", " +
                        _vm.currentVariation.variation.id,
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "form_item" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.formProduct")
                        ) +
                        "\n                        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "input-unit input-unit--floating input-name-field",
                  attrs: { "data-validate": "text" },
                },
                [
                  _c("input", {
                    ref: "contactName",
                    attrs: {
                      type: "text",
                      name: "name",
                      id: "form_name",
                      required: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "form_name" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.formName")
                        ) +
                        "*\n                        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "input-unit input-unit--floating input-name-field",
                  attrs: { "data-validate": "mail" },
                },
                [
                  _c("input", {
                    ref: "contactMail",
                    attrs: {
                      type: "text",
                      name: "email",
                      id: "form_mail",
                      required: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "form_mail" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.formMail")
                        ) +
                        "*\n                        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "input-unit input-unit--floating input-name-field",
                },
                [
                  _c("input", {
                    ref: "contactCompany",
                    attrs: {
                      type: "text",
                      name: "company",
                      id: "form_company",
                      required: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "form_company" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.formCompany")
                        ) +
                        "\n                        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "input-unit input-unit--floating input-name-field",
                },
                [
                  _c("input", {
                    ref: "contactTel",
                    attrs: {
                      type: "tel",
                      name: "telephone",
                      id: "form_tel",
                      required: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "form_tel" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.formPhone")
                        ) +
                        "\n                        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "input-unit input-unit--floating input-name-field",
                  attrs: { "data-validate": "text" },
                },
                [
                  _c("textarea", {
                    ref: "contactMsg",
                    staticClass: "no-resize",
                    attrs: {
                      id: "form_msg",
                      name: "form_msg",
                      maxlength: "140",
                      required: "",
                      placeholder: _vm.$translate(
                        "OD3dprimaV2::Template.formMaxChars"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "form_msg" } }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.formMessage")
                        ) +
                        "*\n                        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-check", attrs: { "data-validate": "" } },
                [
                  _c("input", {
                    ref: "contactPrivacy",
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "form_privacy_check",
                      name: "form_privacy_check",
                      required: "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "form-check-label form-check-label--error-msg",
                      attrs: { for: "form_privacy_check" },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.formPleaseAccept"
                            )
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "form-check-label",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate("OD3dprimaV2::Template.formCheck", {
                          privacyLink: _vm.privacyLink,
                        })
                      ),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                staticClass: "honey",
                attrs: {
                  type: "text",
                  name: "username",
                  autocomplete: "off",
                  tabindex: "-1",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-block",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.sendForm.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$translate("OD3dprimaV2::Template.formSend")) +
                      "\n                    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "small",
                { staticClass: "w-100 text-center mt-2 d-block text-md-left" },
                [
                  _vm._v(
                    "\n                        * " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.contactRequiredField")
                      ) +
                      "\n                    "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { ref: "refRecaptcha" },
            [_vm.recaptchaConfig !== "" ? _c("recaptcha") : _vm._e()],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "eusafety-wrapper" } }, [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "eusafety", tabindex: "-1", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("div", { staticClass: "modal-title h5" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(
                        _vm.$translate("OD3dprimaV2::Template.manufacturerInfo")
                      ) +
                      "\n                        "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", [
                  _c("div", { staticClass: "manufacturer-data" }, [
                    _c("div", [
                      _c("div", { staticClass: "h5" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$translate(
                                "OD3dprimaV2::Template.manufacturer"
                              )
                            ) +
                            "\n                                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasManufacturerDataPart1
                        ? _c("div", [
                            _vm.manufacturerData.legalName
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.manufacturerData.legalName) +
                                      "\n                                        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.manufacturerData.street ||
                            _vm.manufacturerData.houseNo
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.manufacturerData.street) +
                                      " " +
                                      _vm._s(_vm.manufacturerData.houseNo) +
                                      "\n                                        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.manufacturerData.postcode ||
                            _vm.manufacturerData.town
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.manufacturerData.postcode) +
                                      " " +
                                      _vm._s(_vm.manufacturerData.town) +
                                      "\n                                        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.manufacturerCountry != ""
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.manufacturerCountry) +
                                      "\n                                        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.manufacturerData.email
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.manufacturerData.email) +
                                      "\n                                        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.manufacturerData.phoneNumber
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.manufacturerData.phoneNumber) +
                                      "\n                                        "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.manufacturerData.logo
                      ? _c("div", { staticClass: "manufacturer-image" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.manufacturerData.logo,
                              alt: _vm.manufacturerData.name,
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.hasManufacturerDataPart2
                    ? _c("div", { staticClass: "mt-4" }, [
                        _c("div", { staticClass: "h5" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate(
                                  "OD3dprimaV2::Template.responsibleEuPerson"
                                )
                              ) +
                              "\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.manufacturerData.responsibleName
                          ? _c("div", [
                              _vm._v(
                                _vm._s(_vm.manufacturerData.responsibleName)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manufacturerData.responsibleStreet ||
                        _vm.manufacturerData.responsibleHouseNo
                          ? _c("div", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.manufacturerData.responsibleStreet
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.manufacturerData.responsibleHouseNo
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manufacturerData.responsiblePostCode ||
                        _vm.manufacturerData.responsibleTown
                          ? _c("div", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.manufacturerData.responsiblePostCode
                                  ) +
                                  " " +
                                  _vm._s(_vm.manufacturerData.responsibleTown) +
                                  "\n                                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.responsibleManufacturerCountry != ""
                          ? _c("div", [
                              _vm._v(
                                _vm._s(_vm.responsibleManufacturerCountry) +
                                  "\n                                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manufacturerData.responsibleEmail
                          ? _c("div", [
                              _vm._v(
                                _vm._s(_vm.manufacturerData.responsibleEmail)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manufacturerData.responsiblePhoneNo
                          ? _c("div", [
                              _vm._v(
                                _vm._s(_vm.manufacturerData.responsiblePhoneNo)
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          "aria-label": "Close",
          "data-dismiss": "modal",
          type: "button",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }